import React from "react";

interface ProjectCardProps {
  title: string;
  tag: string;
  description: string;
  bullets?: string[];
}

const ProjectCard: React.FC<ProjectCardProps> = ({
  title,
  tag,
  description,
  bullets,
}) => (
  <article className="flex h-full flex-col rounded-2xl border border-slate-700/80 bg-slate-900/80 p-4 dark:bg-slate-50 dark:border-slate-200">
    <header className="mb-2 flex items-center justify-between gap-2">
      <h3 className="text-sm font-semibold text-slate-100 dark:text-slate-900">
        {title}
      </h3>
      <span className="rounded-full bg-slate-800/80 px-2 py-0.5 text-[11px] text-slate-300 dark:bg-slate-200 dark:text-slate-700">
        {tag}
      </span>
    </header>
    <p className="text-xs text-slate-300 dark:text-slate-700">{description}</p>
    {bullets && (
      <ul className="mt-2 list-disc space-y-1 pl-4 text-xs text-slate-400 dark:text-slate-600">
        {bullets.map((b) => (
          <li key={b}>{b}</li>
        ))}
      </ul>
    )}
  </article>
);

export default ProjectCard;
